module.exports = __webpack_public_path__ + "img/40.c10a89f9.jpg";